import { faExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Col, Row } from "react-bootstrap";

const CookiesDisabledCard = () => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12">
          <p>
            <FontAwesomeIcon icon={faExclamation} size={"2x"} color={"#333"} />{" "}
            <span style={{ paddingLeft: "20px" }}>
              The browser has all cookies disabled. In order to operate, LEAP
              requires that Strictly Necessary Cookies are enabled. Please
              enable cookies in the browser to use LEAP.
            </span>
          </p>
        </Col>
      </Row>
    </div>
  );

  return (
    <Card className="flex-fill w-100">
      <Card.Header>
        <Card.Title>
          <h5></h5>
        </Card.Title>
      </Card.Header>
      <Card.Body className="pt-0">{bodyElements}</Card.Body>
      <Card.Footer></Card.Footer>
    </Card>
  );
};

export default CookiesDisabledCard;
